(function () {
  'use strict';

  var TIERS = [
    { min: 1, pct: 0 },
    { min: 2, pct: 10 },
    { min: 3, pct: 15 },
    { min: 4, pct: 20 },
    { min: 5, pct: 25 }
  ];

  function getTier(count) {
    var tier = TIERS[0];
    for (var i = 0; i < TIERS.length; i++) {
      if (count >= TIERS[i].min) tier = TIERS[i];
    }
    return tier;
  }

  document.addEventListener('DOMContentLoaded', function () {
    var root = document.querySelector('[id^="BlueenKitBuilder-"]');
    if (!root) return;

    var cards = Array.from(root.querySelectorAll('.kb-card'));
    var summary = document.querySelector('[data-kb-summary]');
    var liveCount = root.querySelector('[data-kb-live-count]');
    var livePct = root.querySelector('[data-kb-live-pct]');
    var tierMarkers = Array.from(root.querySelectorAll('[data-kb-tier]'));

    var cartQtyByVariant = {}; // variantId (string) -> qty currently in the real cart

    function render(cart) {
      cartQtyByVariant = {};
      cart.items.forEach(function (item) {
        cartQtyByVariant[String(item.variant_id)] = item.quantity;
      });

      var totalCount = cart.item_count;
      var tier = getTier(totalCount);

      summary.classList.toggle('is-visible', totalCount > 0);
      liveCount.textContent = totalCount + (totalCount === 1 ? ' peça' : ' peças');
      livePct.textContent = tier.pct + '% OFF';

      tierMarkers.forEach(function (el) {
        var tierMin = parseInt(el.getAttribute('data-kb-tier'), 10);
        el.classList.toggle('is-reached', totalCount >= tierMin);
        el.classList.toggle('is-current', tierMin === tier.min);
      });

      cards.forEach(function (card) {
        card.syncCardUI && card.syncCardUI();
      });
    }

    function fetchCart() {
      return fetch('/cart.js').then(function (r) { return r.json(); });
    }

    var filterButtons = Array.from(root.querySelectorAll('[data-kb-filter]'));
    filterButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var value = btn.getAttribute('data-kb-filter');
        filterButtons.forEach(function (b) { b.classList.toggle('is-active', b === btn); });
        cards.forEach(function (card) {
          var categories = (card.getAttribute('data-kb-categories') || '').split(' ');
          var show = value === 'all' || categories.indexOf(value) !== -1;
          card.classList.toggle('is-hidden', !show);
        });
      });
    });

    cards.forEach(function (card) {
      var select = card.querySelector('[data-kb-variant-select]');
      var hiddenId = card.querySelector('[data-kb-variant-id]');
      var hiddenPrice = card.querySelector('[data-kb-price]');
      var addBtn2 = card.querySelector('[data-kb-add]');

      function currentVariant() {
        if (select) {
          var opt = select.options[select.selectedIndex];
          return { id: opt.value, price: parseInt(opt.getAttribute('data-price'), 10) };
        }
        return { id: hiddenId.value, price: parseInt(hiddenPrice.value, 10) };
      }

      function syncCardUI() {
        var v = currentVariant();
        var added = !!cartQtyByVariant[v.id];
        addBtn2.classList.toggle('is-added', added);
        addBtn2.textContent = added ? 'Adicionado ✓' : 'Adicionar ao carrinho';
      }
      card.syncCardUI = syncCardUI;

      if (select) {
        select.addEventListener('change', syncCardUI);
      }

      addBtn2.addEventListener('click', function () {
        var v = currentVariant();
        var alreadyAdded = !!cartQtyByVariant[v.id];

        addBtn2.disabled = true;
        addBtn2.textContent = alreadyAdded ? 'Removendo...' : 'Adicionando...';

        var request = alreadyAdded
          ? fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ id: v.id, quantity: 0 })
            })
          : fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ items: [{ id: v.id, quantity: 1 }] })
            });

        request
          .then(function (res) {
            if (!res.ok) throw new Error('cart request failed');
            return fetchCart();
          })
          .then(function (cart) {
            addBtn2.disabled = false;
            render(cart);
            document.dispatchEvent(new CustomEvent('afterCartChanged'));
          })
          .catch(function () {
            addBtn2.disabled = false;
            syncCardUI();
          });
      });
    });

    fetchCart().then(render);
  });
})();
